var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('router-view',{attrs:{"user_profile":_vm.user_profile,"form_data_key":_vm.$route.params.rep_type === 'representative'
        ? 'representative'
        : 'beneficiar',"form_data":_vm.$route.params.rep_type === 'representative'
        ? _vm.user_profile.userRepresentatives[_vm.$route.params.rep_index]
        : _vm.$route.name === 'representatives-form-edit'
        ? _vm.user_profile.userBeneficiar
        : null,"form_data_list":_vm.$route.params.rep_type === 'representative'
        ? _vm.user_representatives
        : [_vm.user_profile.userBeneficiar]}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }